import Translate from "lang/Translate";
import { memo } from "react";

interface ControlLabelProps {
  fieldId: string,
  labelKey?: string
}

const ControlLabel = ({ fieldId, labelKey }: ControlLabelProps) => {
  let labelText = `Labels.${labelKey}`;

  if (fieldId && labelKey)
    return (
      <label htmlFor={fieldId} className="label">
        <Translate text={labelText} />
      </label>
    )
  else return null
};

export default memo(ControlLabel)
